import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { Product } from "types";
import { CartItem } from "types";
import { useCart } from "components/CartContext";
import OrderCartPage from "components/cart/OrderCartPage";
import { getAuthCookie } from "../../utils/authCookies";
import { patchCart, removeCartProductVariant } from "../../api/salesOrderApi";

type ProductObj = {
  product_id: string;
  signage_company_id: string;
  product: Product;
  created_by: {
    id: string;
    name: string;
  };
};

type TaxGroup = {
  id: string;
  name: string;
  status: string;
};

type TaxRule = {
  id: string;
  country: string;
  state: string;
  stateCode: string;
  county: string;
  countyCode: string;
  zipCodes: string[];
  taxRate: number;
  comments: string;
  status: string;
};

const AgentOrderCart = () => {
  const { signageId } = useParams<{ signageId: string }>();
  const { productId } = useParams<{ productId: string }>();
  const [loading, setLoading] = useState(true);
  const token = getAuthCookie("sessionToken");
  const userId = getAuthCookie("userId");
  const [product, setProduct] = useState<Product>();
  const [productobj, setProductObj] = useState<ProductObj>();
  const [productImages, setProductImages] = useState<string[]>([]);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const cartId = localStorage.getItem("cart_id");
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [quantity, setQuantity] = useState(1);
  const handleIncrease = () => setQuantity((prev) => prev + 1); // Increase quantity
  const handleDecrease = () => setQuantity((prev) => (prev > 1 ? prev - 1 : 1)); // Decrease quantity
  const navigate = useNavigate();
  const [subTotal, setSubTotal] = useState(0);
  const [tax, setTax] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectedTaxRate, setSelectedTaxRate] = useState(0);
  const { fetchCart } = useCart();

  // Fetch product data
  // useEffect(() => {
  //   const fetchCartItems = async () => {
  //     try {
  //       setLoading(true);
  //       const response = await fetch(
  //         `${process.env.REACT_APP_API_URL}/carts/${cartId}`,
  //         {
  //           method: "GET",
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );
  //       if (!response.ok) {
  //         throw new Error("Failed to fetch product data");
  //       }

  //       const data = await response.json();
  //       console.log("Fetched Product Data:", data);
  //       if (data) {
  //         setCartItems(data.cart_items);
  //         // setQuantity(data.cart_items[0].quantity);
  //       }
  //     } catch (err) {
  //       console.error("Error fetching product data:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   if (cartId) fetchCartItems();
  // }, [cartId, token]);

  // useEffect(() => {
  //   if (!cartItems?.length) {
  //     setSubTotal(0);
  //     setTax(0);
  //     setTotalAmount(0);
  //     return;
  //   }

  //   // Calculate Subtotal
  //   const calculatedSubTotal = cartItems.reduce(
  //     (total, item) => total + item.quantity * item.unit_retail_price,
  //     0
  //   );

  //   // Fetch the applicable tax rate (assuming first product's tax rule applies)
  //   let applicableTaxRate = 0;
  //   if (cartItems[0]?.tax_details?.tax_rate) {
  //     applicableTaxRate = cartItems[0].tax_details?.tax_rate;
  //     setSelectedTaxRate(applicableTaxRate);
  //   }

  //   // Calculate Tax Amount
  //   const calculatedTax = calculatedSubTotal * (applicableTaxRate / 100);

  //   // Calculate Total Amount
  //   const calculatedTotal = calculatedSubTotal + calculatedTax;

  //   // Update State
  //   setSubTotal(calculatedSubTotal);
  //   setTax(calculatedTax);
  //   setTotalAmount(calculatedTotal);
  // }, [cartItems]);

  const handleQuantityChange = async (cartItem: CartItem, newQuantity: number) => {
    if (newQuantity < 1 || !cartId || !token) return;

    try {
      setLoading(true);
      await patchCart(token, cartId, {
        ...cartItem,
        quantity: newQuantity,
      });

      // ✅ Update local state after successful response
      setCartItems((prevItems) =>
        prevItems?.map((item) =>
          item.product_id === cartItem.product_id &&
            item.variant_id === cartItem.variant_id
            ? { ...item, quantity: newQuantity }
            : item
        )
      );

      toast.success("Cart updated successfully!");
    } catch (error) {
      console.error("Error updating cart:", error);
      toast.error("Failed to update cart item");
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveProduct = async (productId: string, variantId: string) => {
    if (!cartId || !token) return;

    try {
      setLoading(true);

      await removeCartProductVariant(token, cartId, productId, variantId);

      setCartItems((prevCartItems) =>
        prevCartItems?.filter((item) => !(item.product_id === productId && item.variant_id === variantId))
      );

      toast.success("Product removed successfully!");
      fetchCart();
    } catch (err) {
      console.error("Error removing product:", err);
      toast.error("Failed to remove product");
    } finally {
      setLoading(false);
    }
  };


  return (
    // <div className="content">
    //   <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    //   <div className="card">
    //     <div className="card-body">
    //       <h2 className="ps-4">Cart </h2>
    //     </div>
    //   </div>

    //   <div className="row mb-3">
    //     <div className="col-xl-8">
    //       <div className="row align-items-center gy-3 mb-3">
    //         <div className="col-sm">
    //           <div>
    //             <h5 className="fs-14 mb-0">Your Cart ({cartItems?.length ?? 0} items)</h5>
    //           </div>
    //         </div>
    //         <div className="col-sm-auto">
    //           <Link
    //             to="apps-ecommerce-products.html"
    //             className="link-primary text-decoration-underline"
    //           >
    //             {/* Continue Shopping */}
    //           </Link>
    //         </div>
    //       </div>
    //       {cartItems?.length > 0 ? (
    //         cartItems?.map((item: CartItem, index: number) => (
    //           <div key={`${item.product_id}-${item.variant_id}`} className="card product">
    //             <div className="card-body">
    //               <div className="row gy-3">
    //                 <div className="col-sm-auto">
    //                   <div className="avatar-lg bg-light rounded p-1">
    //                     <img
    //                       src={`${process.env.REACT_APP_BASE_URL}${item?.image_url}`}
    //                       alt=""
    //                       className="img-fluid d-block"
    //                     />
    //                   </div>
    //                 </div>
    //                 <div className="col-sm">
    //                   <h5 className="fs-14 text-truncate">
    //                     <Link
    //                       to="/agent/product-details"
    //                       className="text-body"
    //                     >
    //                       {item.name}
    //                     </Link>
    //                   </h5>
    //                   {/* <ul className="list-inline text-muted">
    //                     <li className="list-inline-item">
    //                       Color : <span className="fw-medium">Pink</span>
    //                     </li>
    //                     <li className="list-inline-item">
    //                       Size : <span className="fw-medium">M</span>
    //                     </li>
    //                   </ul> */}

    //                   <div className="input-step">
    //                     <button onClick={() => handleQuantityChange(item, item.quantity - 1)}>–</button>
    //                     <input type="number" value={item.quantity} min="1" onChange={(e) => handleQuantityChange(item, parseInt(e.target.value, 10))} />
    //                     <button onClick={() => handleQuantityChange(item, item.quantity + 1)}>+</button>
    //                   </div>
    //                 </div>
    //                 <div className="col-sm-auto">
    //                   <div className="text-lg-end">
    //                     <p className="text-muted mb-1">Item Price:</p>
    //                     <h5 className="fs-14">
    //                       $
    //                       <span id="ticket_price" className="product-price">
    //                         {item.unit_retail_price}
    //                       </span>
    //                     </h5>
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>

    //             <div className="card-footer">
    //               <div className="row align-items-center gy-3">
    //                 <div className="col-sm">
    //                   <div className="d-flex flex-wrap my-n1">
    //                     <div>
    //                       <button
    //                         className="d-block text-body p-1 px-2"
    //                         onClick={() => handleRemoveProduct(item.product_id,item.variant_id)}
    //                       >
    //                         <i className="ri-delete-bin-fill text-muted align-bottom me-1"></i>{" "}
    //                         Remove
    //                       </button>
    //                     </div>

    //                   </div>
    //                 </div>
    //                 <div className="col-sm-auto">
    //                   <div className="d-flex align-items-center gap-2 text-muted">
    //                     <div>Total :</div>
    //                     <h5 className="fs-14 mb-0">
    //                       $<span className="product-line-price">
    //                         {item.quantity * item.unit_retail_price}
    //                       </span>
    //                     </h5>
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         ))
    //       ) : (
    //         <div className="text-center empty-cart" id="empty-cart">
    //           <div className="avatar-md mx-auto my-3">
    //             <div className="avatar-title bg-info-subtle text-info fs-36 rounded-circle">
    //               <i className="bx bx-cart"></i>
    //             </div>
    //           </div>
    //           <h5 className="mb-3">Your Cart is Empty!</h5>
    //           <Link
    //             to="/agent/suppliers"
    //             className="btn btn-success w-md mb-3"
    //           >
    //             Shop Now
    //           </Link>
    //         </div>
    //       )}

    //       {cartItems?.length > 0 && (
    //         <>
    //           {/* <div className="text-end mb-4">
    //                       <button
    //                         onClick={handleUpdateCart}
    //                         className="btn btn-success btn-label right ms-auto"
    //                       >
    //                         <i className="ri-arrow-right-line label-icon align-bottom fs-16 ms-2"></i>{" "}
    //                         Update Cart
    //                       </button>
    //                     </div> */}
    //           <div className="text-end mb-4">
    //             <Link
    //               to="/agent/order/checkout"
    //               className="btn btn-success btn-label right ms-auto"
    //             >
    //               <i className="ri-arrow-right-line label-icon align-bottom fs-16 ms-2"></i>{" "}
    //               Checkout
    //             </Link>
    //           </div>
    //         </>
    //       )}
    //     </div>

    //     <div className="col-xl-4">
    //       <div className="sticky-side-div">
    //         <div className="card">
    //           <div className="card-header border-bottom-dashed">
    //             <h5 className="card-title mb-0">Order Summary</h5>
    //           </div>

    //           <div className="card-body pt-2">
    //             <div className="table-responsive">
    //               <table className="table table-borderless mb-0">
    //                 <tbody>
    //                   <tr>
    //                     <td>Sub Total :</td>
    //                     <td className="text-end" id="cart-subtotal">
    //                       $
    //                       {cartItems.reduce(
    //                         (total, item) =>
    //                           total + item.quantity * item.unit_retail_price,
    //                         0
    //                       )}
    //                     </td>
    //                   </tr>
    //                   <tr>
    //                     <td>
    //                       Discount{" "}
    //                       {/* <span className="text-muted">(VELZON15)</span> :{" "} */}
    //                     </td>
    //                     <td className="text-end" id="cart-discount">
    //                       $ 0
    //                     </td>
    //                   </tr>

    //                   <tr className="table-active">
    //                     <th>Total (USD) :</th>
    //                     <td className="text-end">
    //                       <span className="fw-semibold" id="cart-total">
    //                         $
    //                         {cartItems.reduce(
    //                           (total, item) =>
    //                             total + item.quantity * item.unit_retail_price,
    //                           0
    //                         )}
    //                       </span>
    //                     </td>
    //                   </tr>
    //                 </tbody>
    //               </table>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <>
      <div className="content">
        <OrderCartPage base="agent" />
      </div>
    </>
  );
};

export default AgentOrderCart;
